import { getBreakpoint } from '@/theme';
import { Box, Stack } from '@mui/material';
import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';

interface Props {
  children: ReactNode;
}

const useStyles = createUseStyles({
  pageContent: {
    padding: '0px 30px',
    boxSizing: 'border-box',
    margin: '24px auto 0px auto',
  },
  [getBreakpoint('md')]: {
    pageContent: {
      padding: '0px 10px',
    },
  },
});

const PageContent: FC<Props> = ({ children }) => {
  const styles = useStyles();

  return (
    <Stack
      justifyContent="flex-start"
      alignItems="center"
      gap={4}
      width="100%"
      height="100%"
      maxWidth={1200}
      className={styles.pageContent}
    >
      {children}

      <Box height={24} />
    </Stack>
  );
};

export default PageContent;
